import ExclamationmarkCircleFill from './ExclamationmarkCircleFill';

export default ExclamationmarkCircleFill;
